module.exports = ""


//////////////////
// WEBPACK FOOTER
// ./src/app/admin/user-management/user-management.component.css
// module id = ./src/app/admin/user-management/user-management.component.css
// module chunks = main